function updateTheme() {
  let theme = localStorage.getItem('theme');
  if (theme === null || theme === 'auto') {
    theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  document.getElementsByTagName('html')[0].setAttribute('data-theme', theme === 'auto' ? 'light' : theme);
}

/**
 * Generated bundle index. Do not edit.
 */

export { updateTheme };
